import { Image, UnstyledButton } from '@mantine/core';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { DeclarationStatus } from '@e-origin/shared';

import { inspectIcon } from '@assets';
import { useGetDeclarationGroupsIds } from '@hooks/declaration/retrieve';

export enum GoToDeclarationIconTabLocation {
  CUSTOMS_STATE = 'customs-state',
  DOCUMENTS = 'documents',
}

interface GoToDeclarationIconProps {
  batchId: string;
  source?: string;
  status?: DeclarationStatus;
  /* default customs state tab */
  tab?: GoToDeclarationIconTabLocation;
}

export const GoToDeclarationIcon = ({ batchId, source, status, tab = GoToDeclarationIconTabLocation.CUSTOMS_STATE }: GoToDeclarationIconProps) => {
  const navigate = useNavigate();
  const [fetchData, setFetchData] = useState(false);
  const { refetch } = useGetDeclarationGroupsIds({
    batchId,
    status,
    enabled: fetchData,
  });

  const handleClick = async (e) => {
    e.stopPropagation();
    setFetchData(true);
    const result = await refetch();

    if (result.data && Object.keys(result.data).length > 0) {
      const firstGroupKey = Object.keys(result.data)[0];
      const declarationId = result.data[firstGroupKey][0];

      if (declarationId) {
        navigate(`/declarations/${declarationId}/${tab}?source=${source}&all-statuses=${!status ? 'true' : 'false'}`);
      }
    }
  };

  return (
    <UnstyledButton onClick={handleClick}>
      <Image src={inspectIcon} w={20} h={20} />
    </UnstyledButton>
  );
};
